// Web Audio + SpeechSynthesis announcement utilities for court assignments.

let audioCtx = null;

function beep() {
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === "suspended") audioCtx.resume();
    const notes = [660, 880, 1046];
    notes.forEach((freq, i) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      const t = audioCtx.currentTime + i * 0.13;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.22, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
      osc.connect(gain);
      gain.connect(audioCtx.destination);
      osc.start(t);
      osc.stop(t + 0.13);
    });
  } catch (e) {
    /* audio not available */
  }
}

function ensureVoices() {
  try {
    if (!("speechSynthesis" in window)) return;
    window.speechSynthesis.getVoices();
  } catch (e) {}
}

if (typeof window !== "undefined" && "speechSynthesis" in window) {
  ensureVoices();
  window.speechSynthesis.onvoiceschanged = ensureVoices;
}

function pickVoice() {
  try {
    const voices = window.speechSynthesis.getVoices() || [];
    return voices.find((v) => /en[-_]/i.test(v.lang) || /^en/i.test(v.lang)) || voices[0] || null;
  } catch (e) {
    return null;
  }
}

// Speaks WITHOUT cancelling the queue, so repeated calls play back-to-back.
function speak(text) {
  try {
    if (!("speechSynthesis" in window)) return;
    if (window.speechSynthesis.paused) window.speechSynthesis.resume();
    const utter = new SpeechSynthesisUtterance(text);
    const v = pickVoice();
    if (v) utter.voice = v;
    utter.rate = 1.0;
    utter.pitch = 1.05;
    utter.volume = 1;
    window.speechSynthesis.speak(utter);
  } catch (e) {
    /* tts not available */
  }
}

export function announce(text, enabled, times = 2) {
  if (!enabled) return;
  try { if ("speechSynthesis" in window) window.speechSynthesis.cancel(); } catch (e) {}
  beep();
  const reps = Math.max(1, times);
  for (let i = 0; i < reps; i++) speak(text);
}

export function primeAudio() {
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    if (audioCtx.state === "suspended") audioCtx.resume();
  } catch (e) {}
  try {
    if ("speechSynthesis" in window) {
      window.speechSynthesis.resume();
      ensureVoices();
    }
  } catch (e) {}
}

// Fully reset the announcement engine (clears stuck speech queue, reloads voices,
// resumes the audio context). Used from account settings when audio stops working.
export function resetAudio() {
  try {
    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel();
      window.speechSynthesis.resume();
      ensureVoices();
    }
  } catch (e) {}
  try {
    if (audioCtx) { audioCtx.close(); }
  } catch (e) {}
  audioCtx = null;
  primeAudio();
}
